module.exports = __webpack_public_path__ + "img/sandbox.cb2f6ad7.png";